import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import S from './RubriquesNavigationAdmin.module.scss';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import RubriqueNavigation from './RubriqueNavigationAdmin/RubriqueNavigationAdmin';
import * as url from '../../../ressources/glossaires/glossaire_liens_pages';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import Filtre from '../../FiltreParProjet/FiltreParProjet';
import Bouton from '../../UI/Bouton/Bouton';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import {
  RiFolderOpenFill,
  RiLineChartFill,
  RiTreasureMapFill,
} from 'react-icons/ri';
import { BsFilter } from 'react-icons/bs';
import { GiAutoRepair, GiMovementSensor } from 'react-icons/gi';
import { FaUsers, FaCogs, FaDatabase } from 'react-icons/fa';
import { MdNotificationsActive } from 'react-icons/md';
import { HiOutlineDocumentReport } from 'react-icons/all';

const RubriquesNavigationAdmin = () => {
  const [showModal, setShowModal] = useState(false);

  const filtreProjectsListId = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );

  const handleOpenModal = (event) => {
    event.preventDefault();
    setShowModal(true);
  };

  const handleCloseModal = (event) => {
    event.preventDefault();
    setShowModal(false);
  };

  const filtreActive = [S.normal];
  if (filtreProjectsListId !== null && filtreProjectsListId.length > 0) {
    filtreActive.push(S.actif);
  }

  return (
    <ul className={[S.RubriquesNavigation].join(' ')}>
      <li className={[S.RubriqueNavigation].join(' ')} key={'projet'}>
        <Link to={url.projet}>
          <div className={s.row}>
            <div className={s.col_3}>
              <RiFolderOpenFill size={25} />
            </div>
            <div className={[s.col_9, s.text_left].join(' ')}>
              {checkMot('projet')}
            </div>
          </div>
        </Link>
      </li>
      <span className={filtreActive.join(' ')} key={'filtre'}>
        <Link to={url.filtre} onClick={handleOpenModal}>
          <div className={s.row}>
            <div className={s.col_3}>
              <BsFilter size={25} />
            </div>
            <div className={[s.col_9, s.text_left, S.FiltreActive].join(' ')}>
              {checkMot('filtre')}
            </div>
          </div>
          <strong>{filtreProjectsListId.join(', ')}</strong>
        </Link>
      </span>
      <Modal
        isOpen={showModal}
        className={S.Modal}
        overlayClassName={S.Overlay}
        onRequestClose={handleCloseModal}
      >
        <Bouton
          ajoutClass={[S.btsFermer].join(' ')}
          type={type_btn.fermer}
          rond={true}
          cliquer={handleCloseModal}
        />
        <Filtre />
      </Modal>
      <RubriqueNavigation link={url.capteur}>
        <div className={s.row}>
          <div className={s.col_3}>
            <GiMovementSensor size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('capteur')}
          </div>
        </div>
      </RubriqueNavigation>
      <RubriqueNavigation link={url.graphe}>
        <div className={s.row}>
          <div className={s.col_3}>
            <RiLineChartFill size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('graphe')}
          </div>
        </div>
      </RubriqueNavigation>
      <RubriqueNavigation link={url.vue}>
        <div className={s.row}>
          <div className={s.col_3}>
            <RiTreasureMapFill size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('vue')}
          </div>
        </div>
      </RubriqueNavigation>
      <RubriqueNavigation link={url.alarme}>
        <div className={s.row}>
          <div className={s.col_3}>
            <MdNotificationsActive size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('alarme')}
          </div>
        </div>
      </RubriqueNavigation>
      <RubriqueNavigation link={url.rapport}>
        <div className={s.row}>
          <div className={s.col_3}>
            <HiOutlineDocumentReport size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('rapport')}
          </div>
        </div>
      </RubriqueNavigation>
      <RubriqueNavigation link={url.utilisateur}>
        <div className={s.row}>
          <div className={s.col_3}>
            <FaUsers size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('utilisateur')}
          </div>
        </div>
      </RubriqueNavigation>
      <RubriqueNavigation link={url.maintenance}>
        <div className={s.row}>
          <div className={s.col_3}>
            <GiAutoRepair size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('maintenance')}
          </div>
        </div>
      </RubriqueNavigation>
      <RubriqueNavigation link={url.tasks}>
        <div className={s.row}>
          <div className={s.col_3}>
            <FaCogs size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('Tasks')}
          </div>
        </div>
      </RubriqueNavigation>
      <RubriqueNavigation link={url.gestionDonnees}>
        <div className={s.row}>
          <div className={s.col_3}>
            <FaDatabase size={25} />
          </div>
          <div className={[s.col_9, s.text_left].join(' ')}>
            {checkMot('Gestion de données')}
          </div>
        </div>
      </RubriqueNavigation>
    </ul>
  );
};

export default RubriquesNavigationAdmin;
